/**
 * Calculates the number of rows that can fit based on the given height and row height.
 * @param {number} height - The height of the container.
 * @param {number} rowHeight - The height of a single row.
 * @returns {number} - The number of rows that can fit.
 */
export function getRowsByHeight(height, rowHeight) {
  return Math.round(height / rowHeight);
}
